import PropTypes from 'prop-types';
import React from 'react';
import T from 'components/T';
import { i18n } from '@international/mastodon-i18n';
import { M } from '@dashboard-experience/mastodon';
import IconPanel from '../../../IconPanel';
import completeIcon from '../../../../images/icons/Complete.svg';

const CompletedNotice = props => {
  const footer = <div />;
  const { email, candidateFacingStatusEnabled } = props;

  const hideConsiderNotice = candidateFacingStatusEnabled;

  return (
    <div data-testid='complete-notice'>
      <IconPanel
        translationKey='components.Report.CompleteNotice'
        icon={
          <img
            src={completeIcon}
            alt={i18n.getStr('components.Report.CompleteNotice.reportComplete')}
          />
        }
        footer={footer}
        detailsCentered
        params={{ email }}
      />
      {!hideConsiderNotice && (
        <M.Card className='mb-3'>
          <T
            className='font-style'
            value='components.Report.CompleteNotice.additionalDetails'
            dangerousHTML
          />
        </M.Card>
      )}

      <M.Card className='mb-3'>
        <T value='components.Report.CompleteNotice.engagement' dangerousHTML />
      </M.Card>
    </div>
  );
};

CompletedNotice.propTypes = {
  email: PropTypes.string.isRequired,
  candidateFacingStatusEnabled: PropTypes.bool,
};

CompletedNotice.defaultProps = {
  candidateFacingStatusEnabled: false,
};

export default i18n.renderTranslation()(CompletedNotice);
